angular.module('ikeweb.spike.capture').service('captureExportService', [
    'CaptureImageExport', 'BasicImageExport', 'spikeCaptureService', 'SpikeUtil', '$analytics',
    function(CaptureImageExport, BasicImageExport, spikeCaptureService, SpikeUtil, $analytics) {

        function newExport(fromCapture, offset) {
            return new CaptureImageExport(fromCapture, offset);
        }

        function newBasicExport(fromCapture) {
            return new BasicImageExport(fromCapture);
        }

        function trackExport(exportType, capture) {

            var event = {
                category: 'Export',
                action: exportType,
                label: capture && capture.id,
                value: 1
            };
            $analytics.eventTrack(exportType, event);
        }

        function download(captureExport) {
            var data = captureExport.getData();
            if (data != null) {
                SpikeUtil.downloadBlob(captureExport.getData(), captureExport.getFilename());
            } else {
                SpikeUtil.downloadURL(captureExport.getURL(), captureExport.getFilename());
            }
        }

        function exportImageOnly(fromCapture, offset) {
            var imageExport = newExport(fromCapture, offset);
            trackExport('IMAGE_ONLY', fromCapture);
            return spikeCaptureService.getCaptureImage(fromCapture)
                .then(imageExport.addImage);
        }

        function exportDeskewed(fromCapture, offset) {
            var imageExport = newBasicExport(fromCapture);
            trackExport('DESKEWED', fromCapture);
            return spikeCaptureService.getCaptureImageDeskewed(fromCapture)
                .then(imageExport.addImage);
        }

        function exportImageWithMeasurements(fromCapture, offset) {
            var imageExport = newExport(fromCapture, offset);
            trackExport('COMPOSITE', fromCapture);
            return spikeCaptureService.getCaptureImage(fromCapture)
                .then(imageExport.addImage)
                .then(imageExport.addMeasurements);
        }

        return {
            imageOnly: exportImageOnly,
            deskewed: exportDeskewed,
            imageWithMeasurements: exportImageWithMeasurements,
            download: download
        };
    }
]).config(['$provide',
    function($provide) {

        var functionsToDecorate = [
            'imageOnly',
            'imageWithMeasurements'
        ];

        $provide.decorator('captureExportService', ['$delegate', 'promiseProgressDecoratorService',
            function($delegate, promiseProgressDecoratorService) {
                return promiseProgressDecoratorService.decorateDelegateWithProgress($delegate, functionsToDecorate);
            }
        ]);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/capture/capture.export.service.js
// module id = 515
// module chunks = 0